/*
* Sticky
*/

$.fn.LatestNews = function(navigation, mobileChecker) {
  let self = this;
  self.type = self.get(0).tagName.toLowerCase() == 'a' ? 'a' : 'div';

  self.clicked = function(e) {
    e.stopImmediatePropagation();
    e.preventDefault();
    if ($(e.target).attr('name') == 'btn-close') {
      self.close();
    } else if (self.type == 'a') {
      navigation.getPage(self.attr("href"))
    }
    return false;
  };

  self.view = function() {
    self.removeClass('latest-news--hidden').addClass('latest-news--visible');
  };

  self.close = function() {
    self.removeClass('latest-news--visible').addClass('latest-news--hidden');
  };

  return function() {
    if (self.type == 'a') {
      self.data('preventTransition', 1);
    }
    self.on('click', self.clicked);
    self.on('mouseenter', self.view);
    $('.latest-news__title').on('click', self.view);
    if (mobileChecker.isMobile) {
      $('.latest-news__title').fadeIn(350);
    } else {
      setTimeout(self.view, 1000);
      setTimeout(function() {
        $('.latest-news__title').show();
      }, 1500);
    }
    return self;
  }();
};
